import { TransactionStageType } from '@client/graphql/__generated__/types';
import {
  FileText,
  Hourglass,
  LucideIcon,
  PenTool,
  Send,
  UserCircle,
} from 'lucide-react';

export interface EventTypeConfig {
  label: string;
  icon: LucideIcon;
}

export const EVENT_TYPE_CONFIG: Record<TransactionStageType, EventTypeConfig> =
  {
    [TransactionStageType.LEAD]: { label: 'Lead', icon: UserCircle },
    [TransactionStageType.SIGNED_AGENCY_AGREEMENT]: {
      label: 'Agency Agreement Signed',
      icon: UserCircle,
    },
    [TransactionStageType.ACTIVE]: { label: 'Active', icon: FileText },
    [TransactionStageType.SUBMITTED_OFFER]: {
      label: 'Offer Submitted',
      icon: Send,
    },
    [TransactionStageType.UNDER_CONTRACT]: {
      label: 'Under Contract',
      icon: Hourglass,
    },
    [TransactionStageType.CLOSED]: { label: 'Closed', icon: PenTool },
    [TransactionStageType.TERMINATED]: { label: 'Terminated', icon: FileText },
  };

export interface PipelineColumnConfig {
  eventType: TransactionStageType;
  label: string;
  icon: LucideIcon;
}

export const PIPELINE_COLUMNS: PipelineColumnConfig[] = [
  {
    eventType: TransactionStageType.SIGNED_AGENCY_AGREEMENT,
    ...EVENT_TYPE_CONFIG[TransactionStageType.SIGNED_AGENCY_AGREEMENT],
  },
  {
    eventType: TransactionStageType.SUBMITTED_OFFER,
    ...EVENT_TYPE_CONFIG[TransactionStageType.SUBMITTED_OFFER],
  },
  {
    eventType: TransactionStageType.UNDER_CONTRACT,
    ...EVENT_TYPE_CONFIG[TransactionStageType.UNDER_CONTRACT],
  },
  {
    eventType: TransactionStageType.CLOSED,
    ...EVENT_TYPE_CONFIG[TransactionStageType.CLOSED],
  },
];
